import React from 'react';

import type { SvgIconClassKey } from '@mui/material';
import { SvgIcon } from '@mui/material';

import { IconColors, useSvgId } from './icon-utils';

export function AlineLogo(props: {
  classes?: Partial<Record<SvgIconClassKey, string>>;
  variant?: 'white' | 'dark';
  width?: number;
}): JSX.Element {
  const { classes, variant = 'dark', width = 94 } = props;
  const height = (width * 23) / 94;
  const gradientId = useSvgId('aline-logo-gradient');

  return (
    <SvgIcon classes={classes} style={{ display: 'block', height, width }} viewBox="0 0 94 23">
      <defs>
        <linearGradient id={gradientId} x1="68.086%" x2="23.699%" y1="0%" y2="100%">
          <stop offset="0%" stopColor={variant === 'white' ? IconColors.White : '#CB3E6D'} />
          <stop
            offset="100%"
            stopColor={variant === 'white' ? IconColors.White : IconColors.Primary}
          />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <path
              d="M40.32 19.17c-1.234 1.1-2.832 1.703-4.485 1.693-3.89 0-6.835-3.194-6.835-7.222 0-4.029 2.955-7.24 6.835-7.24 1.659-.013 3.261.601 4.485 1.72v-.19c0-.821.666-1.487 1.487-1.487.822 0 1.487.666 1.487 1.487v11.376c0 .821-.665 1.487-1.487 1.487-.821 0-1.487-.666-1.487-1.487v-.138zm0-5.543v-.193c-.108-2.43-1.891-4.268-4.16-4.268-2.324 0-4.163 1.91-4.163 4.452 0 2.54 1.839 4.448 4.163 4.448 2.325 0 4.16-1.9 4.16-4.439zM56.28 3.128c.01-.968.8-1.746 1.768-1.74.968.006 1.749.794 1.746 1.762-.003.968-.789 1.751-1.757 1.751-.468-.002-.916-.19-1.246-.522-.33-.333-.513-.783-.51-1.25zm.27 4.86c0-.822.666-1.488 1.487-1.488.822 0 1.487.666 1.487 1.487v11.39c0 .82-.665 1.486-1.487 1.486-.821 0-1.487-.665-1.487-1.487V7.987zm20.767 9.122v2.253c0 .829-.672 1.5-1.5 1.5h-.005c-.829 0-1.5-.671-1.5-1.5V16.46c0-.05.002-.098.007-.146l.002-1.142c-.003-4.082-1.307-5.76-4.143-5.76-2.607 0-3.92 1.188-4.133 4.032v5.92c0 .828-.672 1.5-1.5 1.5h-.02c-.829 0-1.5-.672-1.5-1.5v-4.411c-.012-.36-.012-.709 0-1.048v-5.97c0-.829.671-1.5 1.5-1.5h.02c.68 0 1.255.453 1.438 1.073 1.103-.72 2.505-1.096 4.195-1.096 4.681 0 7.14 3.162 7.143 8.762l-.004 1.936zm13.172-4.877c-.607-1.923-1.827-2.757-3.811-2.757-2.33 0-3.545 1.1-3.963 2.757h7.774zm-3.3 5.63c1.559 0 2.573-.229 3.38-.772.687-.463 1.62-.281 2.082.406.463.687.28 1.62-.406 2.082-1.38.929-2.953 1.284-5.056 1.284-5.377 0-7.645-3.192-7.645-7.13 0-3.914 2.152-7.257 7.134-7.257 4.103 0 6.58 2.526 7.134 7.075.11.894-.588 1.682-1.489 1.682h-9.595c.45 1.613 1.765 2.63 4.46 2.63zM46.517 4.652V1.487c0-.821.666-1.487 1.487-1.487.822 0 1.487.666 1.487 1.487V14.42c0 2.403 1.314 3.634 3.162 3.634.776 0 1.405.63 1.405 1.405 0 .776-.629 1.405-1.405 1.405-3.487 0-6.136-2.482-6.136-6.444V4.652z"
              fill={variant === 'white' ? IconColors.White : '#324A52'}
              fillRule="nonzero"
            />
            <path
              d="M5.381 13.261c1.002.467 1.435 1.657.968 2.658l-2.536 5.438c-.467 1-1.657 1.434-2.658.967-1-.467-1.434-1.657-.967-2.658l2.536-5.437c.466-1.002 1.656-1.435 2.657-.968zm5.072-10.876c1 .467 1.434 1.657.967 2.658l-2.535 5.438c-.467 1.001-1.657 1.434-2.658.968-1.001-.467-1.435-1.657-.968-2.658l2.536-5.438c.467-1.001 1.657-1.434 2.658-.968zm3.613 7.432c1.001.467 1.434 1.657.967 2.658l-4.141 8.882c-.467 1-1.657 1.434-2.658.967-1.001-.467-1.434-1.657-.967-2.658l4.141-8.881c.467-1.001 1.657-1.434 2.658-.968zm2.5 12.712c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
              fill={variant === 'white' ? IconColors.White : `url(#${gradientId})`}
            />
          </g>
        </g>
      </g>
    </SvgIcon>
  );
}
